import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromDiagnoses from './diagnoses.reducer';
import { EffectsModule } from '@ngrx/effects';
import { DiagnosesEffects } from './diagnoses.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromDiagnoses.diagnosesFeatureKey, fromDiagnoses.reducer),
    EffectsModule.forFeature([DiagnosesEffects]),
  ],
})
export class DiagnosesStoreModule {}
